import { render, staticRenderFns } from "./CardInforPolicy.vue?vue&type=template&id=3a6d2d23"
import script from "./CardInforPolicy.vue?vue&type=script&lang=js"
export * from "./CardInforPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports